import { OrderHandlingRequirements } from "../../../dispatch/src/OrderHandlingRequirements";
import { ShipperPONums } from "../../../dispatch/src/ShipperPONums";
import { BillingFreightItemTable } from "../BillingFreightItemTable";
import { BillingOverview } from "../BillingOverview";
import { BillingRates } from "../BillingRates";
import { Button, Checkbox, DataHeader, DataSource, Image, Label, Layout, Panel, Switch, Tab, Table, Tabset, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutBilling extends Layout {
    buttonGoToOrder: Button;
    buttonInitiateStatusProcessing: Button;
    buttonOpenClassic: Button;
    buttonOrderHistory: Button;
    buttonUsers: Button;
    checkboxBolReceived: Checkbox;
    checkboxFloorLoadedFreight: Checkbox;
    checkboxHighValue: Checkbox;
    checkboxIsSplitBill: Checkbox;
    checkboxPreloaded: Checkbox;
    checkboxPrinted: Checkbox;
    checkboxReadyToBill: Checkbox;
    checkboxReadyToProcess: Checkbox;
    checkboxRoundTrip: Checkbox;
    checkboxTeamsRequired: Checkbox;
    dataheaderOrders: DataHeader;
    imageAddHandlingReq: Image;
    labelCreditBadge: Label;
    labelCustomsBroker: Label;
    labelCustomsCoBroker: Label;
    labelHazmatCommodity: Label;
    labelHoldBadge: Label;
    labelMovementView: Label;
    labelOrderView: Label;
    labelPreferredBorderCrossings: Label;
    labelStatusBadge: Label;
    labelTemperatureRange: Label;
    layoutFreightItems: BillingFreightItemTable;
    layoutHandlingReqs: OrderHandlingRequirements;
    layoutImageTable: Layout;
    layoutOverview: BillingOverview;
    layoutRates: BillingRates;
    layoutShipperPONums: ShipperPONums;
    panel10: Panel;
    panel11: Panel;
    panel12: Panel;
    panel13: Panel;
    panel1: Panel;
    panel3: Panel;
    panel5: Panel;
    panel6: Panel;
    panelBorderCrossings: Panel;
    panelBrokerLocations: Panel;
    panelCbpCrossing: Panel;
    panelCbsaCrossing: Panel;
    panelCommodityCheckboxes: Panel;
    panelCommodityExtra: Panel;
    panelCommodityHazmat: Panel;
    panelCustoms: Panel;
    panelCustomsBrokers: Panel;
    panelDataHeaderUpdateOnly: Panel;
    panelGeneralUpdate: Panel;
    panelHazmatComponents: Panel;
    panelMovementTab: Panel;
    panelOrderTab: Panel;
    panelOrderTabs: Panel;
    panelTemperatureRange: Panel;
    sourceBilling: DataSource;
    sourceBillingFreightGroup: DataSource;
    sourceBrltlOrderHdrXFgp: DataSource;
    sourceEquipMatchDetail: DataSource;
    sourceMovement: DataSource;
    sourceOrders: DataSource;
    sourceResponsibleHist: DataSource;
    sourceStop: DataSource;
    stopsTable: Table;
    switchHazmatRouting: Switch;
    switchHoldLoad: Switch;
    switchRecurringOrder: Switch;
    switchTenderReplyTransmitted: Switch;
    tabAccessorials: Tab;
    tabBrltlFreightItems: Tab;
    tabCommodity: Tab;
    tabCustoms: Tab;
    tabDataFusion: Tab;
    tabEquipment: Tab;
    tabGeneral: Tab;
    tabImages: Tab;
    tabInvoiceProcessing: Tab;
    tabOverview: Tab;
    tabRate: Tab;
    tabStops: Tab;
    tableEquipmentRequirementsAsset: Table;
    tableEquipmentRequirementsBrokerage: Table;
    tabsetUpdateBilling: Tabset;
    textboxAgentPayeeId: Textbox;
    textboxBillDate: Textbox;
    textboxBillType: Textbox;
    textboxBillTypeLabel: Textbox;
    textboxBillingUserId: Textbox;
    textboxBlnum2: Textbox;
    textboxBlnum: Textbox;
    textboxBolNote: Textbox;
    textboxBolRecvDate: Textbox;
    textboxBrkQualProfile: Textbox;
    textboxBrokerLocationId: Textbox;
    textboxBrokerageWorkflowId: Textbox;
    textboxCbpCrossingDate: Textbox;
    textboxCbpCrossingLocationId: Textbox;
    textboxCbpCrossingReason: Textbox;
    textboxCbsaCrossingDate: Textbox;
    textboxCbsaCrossingLocationId: Textbox;
    textboxCbsaCrossingReason: Textbox;
    textboxCobrokerLocationId: Textbox;
    textboxCommodity: Textbox;
    textboxCommodityId: Textbox;
    textboxConsigneeRefno: Textbox;
    textboxCopyFromCompany: Textbox;
    textboxCopyFromOrderId: Textbox;
    textboxCopyToCompany: Textbox;
    textboxCopyToOrderId: Textbox;
    textboxCustomerId: Textbox;
    textboxDefMoveType: Textbox;
    textboxDeliveryDate: Textbox;
    textboxEnteredUserId: Textbox;
    textboxEquipmentTypeIdEquipment: Textbox;
    textboxEquipmentTypeIdGeneral: Textbox;
    textboxExternalInvoiceno: Textbox;
    textboxHazmatCode: Textbox;
    textboxHoldReason: Textbox;
    textboxHoldReasonCode: Textbox;
    textboxHoldReasonText: Textbox;
    textboxInvoiceNoString: Textbox;
    textboxInvoiceNumber: Textbox;
    textboxInvoiceRecvDate: Textbox;
    textboxOperationsUser: Textbox;
    textboxOrderLength: Textbox;
    textboxOrderMode: Textbox;
    textboxOrderNumber: Textbox;
    textboxOrderOrderedBy: Textbox;
    textboxOrderType: Textbox;
    textboxOrderValue: Textbox;
    textboxOrderedDate: Textbox;
    textboxOrderedMethod: Textbox;
    textboxOutboundStatusCompleted: Textbox;
    textboxPieces: Textbox;
    textboxPlanningComment: Textbox;
    textboxPreloadTrailerId: Textbox;
    textboxRateSource: Textbox;
    textboxRecurringOrderId: Textbox;
    textboxRevenueCodeId: Textbox;
    textboxShipDate: Textbox;
    textboxShipmentId: Textbox;
    textboxTemperatureMax: Textbox;
    textboxTemperatureMin: Textbox;
    textboxTractorType: Textbox;
    textboxWeight: Textbox;
    textboxXferred2billingDt: Textbox;
}
